import { useCallback } from 'react'

import { Button } from '~/components/Button'

type Props = {
  group: string | undefined
  onDelete: () => void
}

export const DeleteStandardizedSeriesButton: React.FC<Props> = ({
  group,
  onDelete,
}) => {
  const handleConfirmDeleteSeries = useCallback(async () => {
    if (!group) return

    onDelete()
  }, [group, onDelete])

  return (
    <Button color='error' onClick={handleConfirmDeleteSeries}>
      Apagar {group}
    </Button>
  )
}
